import type { TFunction } from 'i18next';

const TRANSLATION_KEYS = [
  'recommendations.modal.thank_you_title',
  'recommendations.modal.recommended_title',
  'recommendations.modal.thank_you_subtitle',
  'recommendations.modal.recommended_subtitle',
  'recommendations.modal.next',
  'recommendations.modal.skip',
  'recommendations.modal.subscribe_to_all',
  'recommendations.modal.subscribe',
  'recommendations.modal.subscribed',
  'recommendations.modal.subscribing',
  'recommendations.modal.sponsored',
] as const;

const getRecommendationsModalTranslations = (t: TFunction): Record<string, string> =>
  Object.fromEntries(TRANSLATION_KEYS.map((key) => [key, t(key)]));

export default getRecommendationsModalTranslations;
